export default __webpack_public_path__ + "static/media/43.b45013d2.jpg";